import {
  DETAIL_FAILED_TRANSACTIONS_LIST_IPB,
  DETAIL_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB,
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function failedTransactionsListDetailsIpbReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_FAILED_TRANSACTIONS_LIST_IPB:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_FAILED_TRANSACTIONS_LIST_IPB_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_FAILED_TRANSACTIONS_LIST_IPB:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
